import "./polyfills";
import { createInertiaApp } from "@inertiajs/react";
import { I18nextProvider } from "react-i18next";
import { createI18n } from "./i18next";

const i18n = await createI18n();

createInertiaApp({
	strictMode: true,
	withApp(app) {
		return <I18nextProvider i18n={i18n}>{app}</I18nextProvider>;
	},
});
